module.exports = __webpack_public_path__ + "static/media/Dr1.349ff006.jpg";